var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoralDrawIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 28.5V1H13C3.4 1 1 8.66667 1 12.5V28.5C1 36.1 8 39.3333 11.5 40C14.5 40.3333 22.4 40.8 30 40C37.6 39.2 40.5 32 41 28.5Z",
    stroke: "#7130FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 12.2776,
    width: 7.47809,
    height: 28.4828,
    transform: "rotate(-44.8898 7.5 12.2776)",
    fill: "#782EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 29.4546L30 31.9546H32.5V29.4546Z",
    fill: "#712FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralDrawIcon);
export default __webpack_public_path__ + "static/media/coral_draw_icon.8d650062ace8aae3fce83c91958c6d78.svg";
export { ForwardRef as ReactComponent };